import { createSlice } from "@reduxjs/toolkit";
import { act } from "react-dom/test-utils";
import { IJson } from "../../../entities/IJson";

export interface IGameSliceState {
  loading: boolean;
  messageInformation: string | undefined;
  captionInformation: string | undefined;
  isStart: boolean;
  isEnd: boolean;
  isWin: boolean;
  isFirstGame: boolean;
  isInformation: boolean;
  isInformationBlocked: boolean;
  time: number;
  theme: string | undefined;
  helper: string | undefined,
  searchWord: string[];
  words: IJson[] | undefined,
  currentIndexWord: number;
  inputWords: string[];
  isResults: boolean;
}

const initialState: IGameSliceState = {
  loading: false,
  messageInformation: undefined,
  captionInformation: undefined,
  isStart: false,
  isEnd: false,
  isWin: false,
  isFirstGame: false,
  isInformation: false,
  searchWord: [],
  time: 0,
  theme: undefined,
  helper: undefined,
  words: undefined,
  currentIndexWord: 0,
  inputWords: [],
  isInformationBlocked: false,
  isResults: false
};

const gameSlice = createSlice({
  name: "game",
  initialState,
  reducers: {
    setIsFirstGame: (state, action) => {
      state.isFirstGame = action.payload;
    },
    setIsInformation: (state, action) => {
      state.isInformation = action.payload;
    },
    setMessageInformation: (state, action) => {
      state.messageInformation = action.payload
    },
    setCaptionInformation: (state, action) => { state.captionInformation = action.payload },
    setSearchWord: (state, action) => {
      state.searchWord = action.payload;
    },
    countTime: (state) => {
      state.time++;
    },
    clearTime: (state) => { state.time = 0 },
    setIsEnd: (state, action) => {
      state.isEnd = action.payload;
    },
    setIsWin: (state, action) => {
      state.isWin = action.payload;
    },
    setIsStart: (state, action) => {
      state.isStart = action.payload;
    },
    setTheme: (state, action) => {
      state.theme = action.payload
    },
    setHelper: (state, action) => {
      state.helper = action.payload
    },
    setWords: (state, action) => {
      state.words = action.payload
    },
    setCurrentIndexWord: (state, action) => {
      state.currentIndexWord = action.payload;
    },
    resetGame: (state) => {
      state.time = 0;
      state.isEnd = false;
      state.isWin = false;
      state.inputWords = [];
      state.isStart = true;
    },
    setInputWords: (state, action) => {
      state.inputWords = [...state.inputWords, action.payload]
    },
    setIsInformationBlocked: (state, action) => {
      state.isInformationBlocked = action.payload
    },
    setIsResults: (state, action) => {
      state.isResults = action.payload
    }
  }
});

const { actions, reducer } = gameSlice;

export default reducer;

export const {
  countTime,
  setIsEnd,
  setIsFirstGame,
  setIsInformation,
  setIsStart,
  setIsWin,
  setSearchWord,
  setCaptionInformation,
  setMessageInformation,
  setTheme,
  setHelper,
  setWords,
  setCurrentIndexWord,
  clearTime,
  resetGame,
  setInputWords,
  setIsInformationBlocked,
  setIsResults
} = actions;
